import angular from 'angular';
import { STATES } from '../../../constants/';
import { DmvConfig } from './dmv.config.js';

export const DmvModule = angular.module(STATES.STEP_DMV, []).config(DmvConfig);
